import React from 'react';
import styled from 'styled-components';

import ToggleMapButton from './components/ToggleMapButton';
import ShowFiltersButton from './components/ShowFiltersButton';
import SubscribeButton from './components/SubscribeButton';

import { getFiltersCount } from './utils';
import type { IFloatingPanelMobile } from './types';

export const FloatingPanelMobile = (props: IFloatingPanelMobile) => {
  const {
    mapView,
    toggleFilters,
    toggleSubscribe,
    toggleMap,
    setVisibleHotelsLimit,
    isWhitelabel,
    isHotelOnly,
    isSubscribed = false,
    isMountainsActive = false,
    onCloseMountains,
  } = props;

  const filtersCount = getFiltersCount();

  const handleSubscribeToggle = () => {
    toggleSubscribe();

    if (isMountainsActive && onCloseMountains) {
      onCloseMountains();
    }
  };

  return (
    <FloatingPanelWrapper>
      <BottomPanelWrapper>
        {!isWhitelabel && !isHotelOnly && (
          <SubscribeButton
            isSubscribed={isSubscribed}
            toggleSubscribe={handleSubscribeToggle}
          />
        )}

        <ShowFiltersButton
          toggleFilters={toggleFilters}
          count={filtersCount}
          isWhitelabel={isWhitelabel}
          isHotelOnly={isHotelOnly}
        />

        <ToggleMapButton
          toggleHandler={toggleMap}
          setVisibleHotelsLimit={setVisibleHotelsLimit}
          mapView={mapView}
        />
      </BottomPanelWrapper>
    </FloatingPanelWrapper>
  );
};

const FloatingPanelWrapper = styled.div<{ $isPopupOnMapOpened?: boolean }>`
  height: 56px;
  position: relative;

  // Карта не перекрывает панельку
  z-index: 2;

  padding: 0 15px;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  pointer-events: none;

  button {
    pointer-events: all;
  }
`;

const BottomPanelWrapper = styled.div`
  display: flex;
  box-shadow: 0px 1px 2px rgba(210, 208, 197, 0.9),
    0px 10px 15px rgba(216, 214, 204, 0.9);
  border-radius: 28px;
`;
